import React from 'react';
import type { ImgHTMLAttributes } from 'react';

import type { SidebarBrand } from 'utils/companyBrand';

interface SideBarImageLogoProps extends ImgHTMLAttributes<HTMLImageElement> {
  sidebarBrand?: SidebarBrand;
}

const SideBarImageLogo = ({ sidebarBrand, ...imgProps }: SideBarImageLogoProps) => {
  const { alt, src } = imgProps;

  if (!src && !sidebarBrand) {
    return null;
  }

  return <img {...imgProps} alt={alt ?? sidebarBrand?.alt ?? ''} src={src ?? sidebarBrand?.src} />;
};

export default SideBarImageLogo;
